import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'
import { v2ReservationGroupKeys } from './use-v2-reservationgroup-find-query'
import { v2ReservationGroupRemovedKeys } from './use-v2-reservationgroup-find-removed-query'

type UpdateReservationGroupBody = Parameters<typeof apiClient.v2.apiV2ReservationgroupElUpdate>[0]

const updateReservationGroup = async (body: UpdateReservationGroupBody) => {
  const { data } = await apiClient.v2.apiV2ReservationgroupElUpdate(body)
  return checkApiResponse(data)
}

export const useV2ReservationGroupUpdateMutation = ({ options }: MutationComposableParams<unknown, UpdateReservationGroupBody> = {}) => {
  const queryClient = useQueryClient()
  return useMutation(() => {
    const resolved = resolveMaybeGetter(options ?? {})
    return {
      mutationFn: updateReservationGroup,
      ...resolved,
      // 저장 성공 시 도메인 캐시를 무효화한다 — 다음 조회가 fresh 데이터를 가져온다
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({ queryKey: v2ReservationGroupKeys.all })
        queryClient.invalidateQueries({ queryKey: v2ReservationGroupRemovedKeys.all })
        return (resolved as { onSuccess?: (...args: unknown[]) => unknown }).onSuccess?.(data, variables, context)
      },
    }
  })
}
